import { render, staticRenderFns } from "./ClosePriceFilters.vue?vue&type=template&id=cffedf1a"
import script from "./ClosePriceFilters.vue?vue&type=script&lang=js"
export * from "./ClosePriceFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports